// extracted by mini-css-extract-plugin
module.exports = {"List":"HowItWorks_List__3edDP"};